const initialState = {
  height: false
}

const mapModalHeight = (state = initialState, action) => {
  switch (action.type) {
    case "SET_EDIT_HEIGHT":
      return { ...state, height: action.val }
    default:
      return state
  }
}

export default mapModalHeight
